import { render, staticRenderFns } from "./roomBindOwnerList.vue?vue&type=template&id=f72acbe6&scoped=true"
import script from "./roomBindOwnerList.vue?vue&type=script&lang=js"
export * from "./roomBindOwnerList.vue?vue&type=script&lang=js"
import style0 from "./roomBindOwnerList.vue?vue&type=style&index=0&id=f72acbe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72acbe6",
  null
  
)

export default component.exports